export default function CompanyIntro() {
  return (
    <section className="relative py-24 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 text-white overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-72 h-72 bg-amber-500 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500 rounded-full blur-3xl"></div>
      </div>
      
      <div className="max-w-7xl mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h1 className="text-5xl font-bold mb-6">
            회사소개
          </h1>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-500 to-amber-600 mx-auto"></div>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <img
              src="https://public.readdy.ai/ai/img_res/15175146278d9b2ac50689b872ff357a.jpg"
              alt="재기목형 작업장"
              className="w-full h-full object-cover rounded-2xl shadow-2xl"
            />
          </div>

          <div className="space-y-6">
            <h2 className="text-3xl font-bold text-amber-400">
              30년 전통의 목형 제작 전문기업
            </h2>
            <p className="text-lg leading-relaxed text-gray-200">
              주식회사 재기목형은 서울 을지로 방산시장에서 30여 년간 목형을 제작하며 성장해온 전문 기업입니다.
            </p>
            <p className="text-lg leading-relaxed text-gray-200">
              장기근속 직원들의 숙련된 기술과 전문성으로 특수목형 제작 및 개발에 힘쓰고 있으며, 전국에 거래처를 두고 업계 최고의 제품을 생산하고 있습니다.
            </p>
            <p className="text-lg leading-relaxed text-gray-200">
              포장재 및 제품 생산용 특수목형 제작을 전문으로 하며, 레이저 가공 브랜드 '뉴테크'를 통해 최신 기술과 전통 기술을 결합한 토탈 솔루션을 제공합니다.
            </p>

            <div className="grid grid-cols-3 gap-6 pt-8">
              <div className="text-center">
                <div className="text-4xl font-bold text-amber-400 mb-2">30+</div>
                <div className="text-sm text-gray-300">년 경력</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-amber-400 mb-2">100+</div>
                <div className="text-sm text-gray-300">거래처</div>
              </div>
              <div className="text-center">
                <div className="text-4xl font-bold text-amber-400 mb-2">1,000+</div>
                <div className="text-sm text-gray-300">프로젝트</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
